import * as React from 'react';

export const Intro = ({ children }) => {
    return <p className="article-subtitle article-intro">{children}</p>;
}

export const Subtitle = ({ children }) => {
    return <h2 className="article-subtitle">{children}</h2>;
}

export const Text = ({ children, type = "" }) => {
    return <p className={`article-paragraph ${type}`}>{children}</p>;
}

export const IFrame = ({ src }) => {
    return <iframe className="article-iframe" src={src} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} />
}

export const List = ({ children }) => {
    return <ul className="article-list">{children}</ul>;
}

export const ListItem = ({ children }) => {
    return <li className="article-lisitem">{children}</li>;
}

export const Link = ({ children, href = "" }) => {
    return <a href={href || children} target="_blank">{children}</a>
}

export const Image = ({ children, src, alt = "" }) => {
    return <figure className="article-image-container">
        <img className="article-image" src={`/images/blog/${src}`} alt={alt} />
        <figcaption>{children}</figcaption>
    </figure>
}

export const Banner = ({ bannerImg, bannerLink }) => {
    return (
        <a href={bannerLink} className="article-banner">
            <img src={`/images/blog/banners/${bannerImg}`} alt="" />
        </a>
    );
}

export const ButtonLink = ({ href, text }) => {
    return (
        <a href={href} className="article-button">
            {text}
        </a>
    )
}



// WEBPACK FOOTER //
// ./src/components/Blog/Articles/ArticleComponents.tsx